import React from 'react';

type CardOutlineSvgProps = {
  width: number;
  height: number;
};

const CardOutlineSvg: React.FC<CardOutlineSvgProps> = ({ width, height }) => {
  const viewBox = `0 0 ${width} ${height}`;
  return (
    <svg viewBox={viewBox} width="100%" height="100%">
      <rect
        x="0"
        y="0"
        width="100%"
        height="100%"
        fill="none"
        stroke="#06ff00"
        strokeWidth="1"
        strokeDasharray="2, 2"
      >
        <animate
          attributeName="stroke-dashoffset"
          from="20"
          to="0"
          dur="2s"
          repeatCount="indefinite"
        />
      </rect>
    </svg>
  );
};

export default CardOutlineSvg;
